import React from 'react';

export function PricingPlanCard({ plan, onPromote }) {
    const cardClassNames = [
        'pricing-card',
        plan.cardClass,
        plan.popular ? 'popular' : '',
    ].filter(Boolean).join(' ');

    const badgeClassNames = [
        'card-badge',
        plan.popular ? 'popular-badge' : '',
    ].filter(Boolean).join(' ');

    return (
        <div className={cardClassNames}>
            <div className={badgeClassNames}>{plan.badgeLabel}</div>
            <div className="card-top">
                <h3 className="card-title">{plan.title}</h3>
                <div className="card-subtitle">{plan.subtitle}</div>
                <div className="card-price">PLN {plan.price}</div>
                <button
                    type="button"
                    className="card-button"
                    onClick={() => onPromote(plan.id)}
                >
                    Promuj wydarzenie →
                </button>
            </div>
            <div className="card-description">{plan.descriptionParts}</div>
        </div>
    );
}
